import React from "react";
import { Pagination as BootstrapPagination } from "react-bootstrap";

const Pagination = ({
  currentPage,
  setCurrentPage,
  totalPages,
  data,
  itemsPerPage,
}) => {
  // Calculate the range of pages to display
  const pageRange = 3;
  const startPage = Math.max(1, currentPage - Math.floor(pageRange / 2));
  const endPage = Math.min(totalPages, startPage + pageRange - 1);

  return (
    <div className="pagination-container">
      <div className="pagination">
        <BootstrapPagination className="align-items-center">
          <div className="prevvtn">
            <BootstrapPagination.Prev
              onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
            />
          </div>
          {Array.from({ length: endPage - startPage + 1 }).map((_, index) => (
            <BootstrapPagination.Item
              key={startPage + index}
              active={startPage + index === currentPage}
              onClick={() => setCurrentPage(startPage + index)}
            >
              {startPage + index}
            </BootstrapPagination.Item>
          ))}
          {totalPages > 3 && (
            <React.Fragment>
              {endPage < totalPages && (
                <React.Fragment>
                  <BootstrapPagination.Item
                    onClick={() => setCurrentPage(totalPages)}
                    className="last_child"
                  >
                    Last
                  </BootstrapPagination.Item>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          <div className="prevvtn">
            <BootstrapPagination.Next
              onClick={() =>
                currentPage < totalPages && setCurrentPage(currentPage + 1)
              }
            />
          </div>
        </BootstrapPagination>
      </div>
    </div>
  );
};

export default Pagination;
